
export function convertDate (date) {
  return date !== undefined && typeof date === 'number' ? new Date(date) : date;
}



// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionsEditForm/helper.js